

import React, { useState } from 'react';
import '../../MainSection.css'
import { FiCopy } from 'react-icons/fi';




const TmatrixInfo = ({ data }) => {

    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
      navigator.clipboard.writeText(info.unique_key);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    };

    


    

    const getKeywords = (currentElement) => {
    
        const keywordString = currentElement?.tmatrix_Keyword;
        //console.log(typeof(keywordString))
    
        //console.log(keywordString)
    
        if (!keywordString) {
           
            return "No keywords"; 
        }
    
        try {
    
          if (typeof(keywordString) === 'string') {
               return keywordString;
    
          }else{
            
          const sanitizedString = keywordString.replace(/'/g, '"');
          const keywordsArray = JSON.parse(sanitizedString);
    
            
            if (Array.isArray(keywordsArray)) {
                return keywordsArray.join(', ');
            } else {
                
                return "Invalid keyword format"; 
            }}
        } catch (error) {
            console.error("Parsing error:", error);
            return "Error parsing keywords"; 
        }
    };

   

    const info = {
        title : 'General Information',
        Shape: data.geometry_shape,
        Material: data.material_name,
        Description: data.tmatrix_description,
        unique_key : data.unique_key,
        
        Keyword: getKeywords(data)
    };








return(


<div className="info-container">
            <h2>{info.title}</h2>
            <p><strong>Shape:</strong> {info.Shape}</p>
            <p><strong>Material:</strong> {info.Material}</p>
            <p><strong>Description:</strong> {info.Description}</p>
            <p><strong>Keyword:</strong> {info.Keyword}</p>
            <p className="break-word">
                <strong>T-matrix ID:</strong> {info.unique_key}
                <span className="copy-icon" onClick={handleCopy} title="Copy to clipboard">
                <FiCopy />
                </span>
                {copied && <span className="copy-confirm">Copied!</span>}
            </p>
        </div>
)


};

export default TmatrixInfo ;